<template>
  <div>
    <Navbar />
      <div class="owner-body">
        <div class="sidebar">
            <Sidebar />
        </div>
        <div class="page">
          <div v-if="isLoading">
            <Loading />
          </div>
          <div v-else>
            <card-component class="card-componet">
              <div class="roles">
                  <div class="roles-heading">
                      <h3>Roles</h3>
                  </div>
                  <div class="add-button">
                      <b-button @click.prevent="OpenAddModal()">Add new user</b-button>
                  </div>
                  <div class="roles-table">
                      <!-- <b-table :data="users" :columns="columns"></b-table> -->
                      <b-table :data="users">
                        <b-table-column field="name" label="NAME" v-slot="props">
                            {{ props.row.name}}
                        </b-table-column>
                        <b-table-column field="address" label="LOCATION" v-slot="props">
                            {{ props.row.address }}
                        </b-table-column>
                        <b-table-column field="role" label="ROLE" v-slot="props">
                            {{ props.row.role }}
                        </b-table-column>
                        <b-table-column field="edit" label="EDIT" v-slot="props">
                          <b-button class="icon-button" @click.prevent="openEditModal('edit', props.row.id)">
                            <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <line x1="2" y1="3.65" x2="12" y2="3.65" stroke="#736F6F" stroke-width="0.7"/>
                              <line x1="2" y1="5.65" x2="10" y2="5.65" stroke="#736F6F" stroke-width="0.7"/>
                              <line x1="2" y1="7.65" x2="9" y2="7.65" stroke="#736F6F" stroke-width="0.7"/>
                              <line x1="2" y1="9.65" x2="8" y2="9.65" stroke="#736F6F" stroke-width="0.7"/>
                              <line x1="2" y1="11.65" x2="7" y2="11.65" stroke="#736F6F" stroke-width="0.7"/>
                              <line x1="2" y1="13.65" x2="6" y2="13.65" stroke="#736F6F" stroke-width="0.7"/>
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9387 8.68964L12.8271 8.67217L12.7402 8.74446L9.96654 11.0522L9.95779 11.0594L9.94973 11.0675L7.15606 13.8589L7.1092 13.9057L7.09167 13.9696L6.56599 15.8859L6.45559 16.2883L6.86252 16.1958L8.6649 15.7859L8.73518 15.7699L8.78616 15.719L11.5798 12.9276L13.9079 10.6014L13.9506 10.5588L13.9691 10.5013C14.0441 10.2688 14.1023 10.0536 14.125 9.85975C14.1479 9.66526 14.1377 9.47181 14.0558 9.29584C13.8867 8.93264 13.4806 8.77446 12.9387 8.68964ZM12.7836 9.3588L12.9715 9.20246C13.4165 9.28569 13.5548 9.40437 13.6025 9.50684C13.6308 9.5677 13.6453 9.65764 13.6285 9.80144C13.6215 9.86075 13.6096 9.92573 13.5931 9.99723L12.7836 9.3588ZM12.3907 9.68571L10.2951 11.4292L7.55633 14.1658L7.15858 15.6157L8.48374 15.3143L11.2264 12.5739L13.3554 10.4466L12.3907 9.68571Z" fill="#736F6F"/>
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0.7H12C12.718 0.7 13.3 1.28203 13.3 2V9.17766L14 9.88831V2C14 0.895431 13.1046 0 12 0H2C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.89543 16 2 16H6.01854L6.72918 15.3H2C1.28203 15.3 0.7 14.718 0.7 14V2C0.7 1.28203 1.28203 0.7 2 0.7Z" fill="#736F6F"/>
                            </svg>
                          </b-button>
                          <b-button class="icon-button" @click="deleteThisUser(props.row.id)">
                            <svg class="svg2" width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 2.3324V14.4622C1.54599 17.1604 2.18718 17.6481 3.47059 18H13.3529C14.3582 17.0726 14.646 16.098 15 14.4622V2.3324C9.22992 0.627447 6.14931 0.485699 1 2.3324ZM1 2.3324C6.6903 3.36724 9.6653 3.39974 14.5882 2.3324" stroke="black" stroke-width="0.7"/>
                              <path d="M4 5V15M4 5V15" stroke="black" stroke-width="0.7"/>
                              <path d="M12 5V15M12 5V15" stroke="black" stroke-width="0.7"/>
                              <path d="M8 7V14M8 7V14" stroke="black" stroke-width="0.7"/>
                            </svg>
                          </b-button>
                        </b-table-column>
                      </b-table>
                  </div>
              </div>
            </card-component>
          <b-modal :active.sync="isEditModalActive" has-modal-card>
            <edit-user-role
              @edit-role="onEditRole"
              :action="action"
              :userData="itemData"
              :selectedId="selectedId"
            ></edit-user-role>
          </b-modal>
          </div>
          <b-modal :active.sync="isAddModalActive" has-modal-card>
            <add-user-role
              @add-role="onAddRole"
              :companyIdOfLoggedUser="companyIdOfLoggedUser"
              :facility="facility"
            ></add-user-role>
          </b-modal>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Navbar from '@/components/NavBar.vue';
import Sidebar from '@/components/OwnerSidebar.vue';
import CardComponent from '@/components/CardComponent.vue';
import Loading from '@/components/Loading.vue';
import EditUserRole from '@/components/modal/EditUserRole.vue';
import AddUserRole from '@/components/modal/AddUserRole.vue';
import { cloneDeep } from 'lodash';

export default {
  name: 'Roles',
  components: {
    Navbar,
    Sidebar,
    CardComponent,
    Loading,
    EditUserRole,
    AddUserRole
  },
  data() {
    return {
      isLoading: false,
      isEditModalActive: false,
      isAddModalActive: false,
      onEditRole: '',
      onAddRole: '',
      action: '',
      selectedId: '',
      itemData: {}
    };
  },
  created() {
    const tank = {
      company_id: this.getLoggedUser.company_id
    };
    this.fetchUsers(tank);
  },
  watch: {
    getStatus(val) {
      if (val === 'loading') {
        this.isLoading = true;
      } else if (val === 'success') {
        this.isLoading = false;
      }
    },
    isEditModalActive(val) {
      if (!val) {
        this.action = '';
        this.selectedId = null;
        this.itemData = {};
      }
    },
    selectedId(val) {
      if (val) {
        const clientItem = this.users.find(
          (data) => data.id === val
        );
        if (Object.keys(clientItem).length) {
          this.itemData = cloneDeep({ ...clientItem });
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getLoggedUser', 'getStatus']),
    ...mapGetters('apps', {
      users: 'getUsers', facility: 'getFacilityDetails'
    }),
    companyIdOfLoggedUser() {
      return this.getLoggedUser.company_id;
    }
  },
  methods: {
    ...mapActions('apps', ['fetchUsers', 'deleteUser']),
    deleteThisUser(id) {
      this.selectedId = id;
      const data = {
        company_id: this.getLoggedUser.company_id,
        user_id: id
      };
      this.deleteUser(data);
    },
    openEditModal(val, id) {
      if (val === 'edit') {
        this.action = val;
        this.selectedId = id;
      }
      this.isEditModalActive = true;
    },
    OpenAddModal() {
      this.isAddModalActive = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.roles-heading h3 {
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  color: #736F6F;
  margin-bottom: 27px;
}
.roles-heading {
  border-bottom: 1px solid #C4C4C4;
}
.add-button button {
  width: 207.11px;
  height: 40px;
  background: #3887F6;
  box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15);
  display: block;
  margin: 24px 0 24px auto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 18px;
  color: #FFFFFF;
}
.icon-button {
  background: transparent;
  border: none;
  // .svg2 {
  //   margin-left: 10px;
  // }
}
</style>
